import Icon from 'components/atoms/Icon'
import ListItem from 'components/atoms/ListItem'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedList from 'components/atoms/ThemedList'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Form from 'components/molecules/Form'
import _ from 'lodash'
import React, { useState } from 'react'
import { styles } from 'scenes/home/coworker/filter/_styles'
import Spinner from "theme/Spinner"
import { colorList } from 'utils/colors'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import FetchManagementJobtitle from 'utils/fetch/management/FetchManagementJobtitle'
import HelperString from 'utils/helper-string'
import i18n from 'utils/i18n'

const SearchSelectJobtitleComponent = ({ selectedJobtitles = [], subtitle = true, readonly = false, onSubmit }) => {
	
	const [ results, setResults ] = useState( [] )
	const [ searching, setSearching ] = useState( false )
	const [ availableFor, setAvailableFor ] = useState( selectedJobtitles )
	
	const renderJobtitleListItem = ( { item } ) => {
		let title = item?.name;
		if( item.active === "no" ) {
			title += ` (${ i18n.t('management:generic.active.no').toLowerCase() })`
		}
		
		let accessoryRight = null;
		if( !readonly ) {
			accessoryRight = (
				<ThemedPressable onPress={ onJobtitleRemove.bind( this, item.guid ) }>
					<Icon
						icon={ IconSystemConstants.TRASH }
						style={ styles.icon }
						color={ colorList.RED.primary }
					/>
				</ThemedPressable>
			)
		}
		
		return (
			<ListItem
				title={ title }
				accessoryRight={ accessoryRight }
			/>
		)
	}
	
	const onJobtitleSelect = ( index ) => {
		// check if it's already added
		let exists = false;
		availableFor.forEach( o => {
			if( o.guid === results[ index ]?.guid ) {
				exists = true;
			}
		});

		// If it exists, remove it, else add it
		if( exists ) {
			const newAvailableFor = availableFor.filter( item => {
				return item.guid !== results[index]?.guid;
			} );
			setAvailableFor( newAvailableFor );
			return;
		}

		const newAvailableFor = [ ...availableFor, results[ index ] ];
		setAvailableFor( newAvailableFor );
	}
	
	const onJobtitleRemove = ( guid ) => {
		setAvailableFor( availableFor.filter( item => {
			return item.guid !== guid;
		} ) )
	}
	
	const searchJobtitleChanged = ( value ) => {
		// Always lowercase
		value = value?.toLowerCase() ?? '';
		
		// Only when there is a value do a fetch :)
		if( !_.isEmpty( value ) ) {
			FetchManagementJobtitle.fetchAll({
				employeeCount: false,
				dispatchDataToStore: false,
				variables: {
					search: value
				},
				callbackStart: () => {
					setSearching( true )
					setResults( [] )
				},
				callbackSuccess: ( { jobtitles } ) => {
					setSearching( false )
					setResults( jobtitles )
				},
				callbackError: ( result ) => {
					setSearching( false )
					setResults( [] )
				}
			})
		}
	}
	
	const saveAvailableForJobtitlesForm = ( values, { callback } = {} ) => {
		const jobtitles = [];
		availableFor.forEach( ( jobtitle ) => {
			jobtitles.push( jobtitle.guid );
		})
		
		onSubmit( jobtitles, { callback })
	}
	
	const jobtitleOptions = _.map( results, jobtitle => {

		let title = jobtitle.name;
		if( jobtitle.active === "no" ) {
			title += ` (${ i18n.t('management:generic.active.no').toLowerCase() })`
		}

		// Check the availableFor
		const isInAvailableFor = _.find( availableFor, o => {
			return o.guid === jobtitle.guid;
		} ) !== undefined;

		return {
			title: title,
			isChecked: isInAvailableFor,
		}
	});
	
	// Create the available for fields
	const formFieldsAvailableFor = [
		{
			name: 'jobtitles',
			required: true,
			label: i18n.t('management:form.jobtitles.title'),
			type: FormFieldsConstants.AUTOCOMPLETE,
			onSelect: onJobtitleSelect,
			onChangeText: _.debounce( searchJobtitleChanged.bind( this ), 400 ),
			options: jobtitleOptions,
			accessoryRight: searching ? () => {
				return <Spinner size='small' color={colorList.PRIMARY.primary} />;
			} : null
		},
	];
	
	return (
		<ThemedBlock
			header={[
				i18n.t('management:form.available_for.title'),
				subtitle === true ? i18n.t('management:form.available_for.description') : null
			]}
			shadow
			mediumPadding>
			
			{ !readonly && (
				<Form
					key={ HelperString.hash( 'form-available-for-jobtitles' ) }
					fields={ formFieldsAvailableFor }
					onSubmit={ saveAvailableForJobtitlesForm }
					forceSaveButton={ true }
				/>
			)}
			
			<ThemedList
				data={ _.filter( availableFor ) }
				renderItem={ renderJobtitleListItem.bind( this ) }
			/>
		</ThemedBlock>
	);
}

export default SearchSelectJobtitleComponent
